<template>
    <div class="types-picker">
        <div class="tp-col">
            <kimsa-combobox :label="$t('exercises.category')" :placeholder="$t('exercises.pick_one_category')" dense
                searchable multiple-with-chips placeholder-class item-text="label"
                :items="categoriesPickerOptions" :value="categoriesValue"
                @change="categories = toNames($event)" ref="categories" />
        </div>
        <div class="tp-col">
            <kimsa-combobox :label="$t('exercises.type')" :placeholder="$t('exercises.pick_type')" dense
                searchable multiple-with-chips placeholder-class item-text="label"
                :items="typesOptions" :value="typesValue" :readonly="categories.length === 0"
                @change="types = toNames($event)" ref="types" />
        </div>
        <div v-if="$slots.default" class="tp-col">
            <slot />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import KimsaCombobox from '@/components/common/inputs/KimsaCombobox'

export default {
    name: "ExerciseTypesPicker",
    components: { KimsaCombobox },
    props: {
        defaultCategories: {
            type: Array,
            default: () => []
        },
        defaultTypes: {
            type: Array,
            default: () => []
        },
        forceValue: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            categories: [],
            types: []
        }
    },
    computed: {
        ...mapState(['categoriesOptions']),
        categoriesValue(vm = this) {
            return vm.categoriesPickerOptions.filter(item => vm.categories.includes(item.name))
        },
        typesValue(vm = this) {
            return vm.typesOptions.filter(item => vm.types.includes(item.name))
        },
        categoriesPickerOptions(vm = this) {
            return vm.categoriesOptions.map(category => ({
                name: category.name,
                value: category.name,
                label: vm.categoryLabel(category.name),
            })).sort((a, b) => a.label.localeCompare(b.label))
        },
        typesOptions(vm = this) {
            if (vm.categories.length === 0) return []
            let typesOptions = []
            vm.categoriesOptions.forEach(category => {
                if (vm.categories.includes(category.name)) typesOptions.push(...category.types)
            })
            typesOptions = typesOptions.map(type => {
                return {
                    name: type,
                    value: type,
                    label: vm.typeLabel(type),
                }
            })
            let hash = {}
            return typesOptions.filter(type => hash[type.value] ? false : hash[type.value] = true).sort((a, b) => a.label.localeCompare(b.label));
        }
    },
    async mounted() {
        const vm = this
        if (vm.categoriesOptions.length === 0) await vm.fetchExerciseCategories()
        vm.setDefaults()
    },
    methods: {
        ...mapActions(['fetchExerciseCategories']),
        toNames(selection) {
            return (selection || []).map(item => (item && typeof item === 'object') ? item.name : item)
        },
        reset() {
            const vm = this
            vm.categories = []
            vm.types = []
        },
        setDefaults() {
            const vm = this
            if (vm.defaultCategories.length > 0 || vm.forceValue) vm.categories = vm.defaultCategories
            if (vm.defaultTypes.length > 0 || vm.forceValue) vm.types = vm.defaultTypes
        }
    },
    watch: {
        defaultCategories() {
            this.setDefaults()
        },
        defaultTypes() {
            this.setDefaults()
        },
        categories(val) {
            this.$emit('change:categories', val)
        },
        types(val) {
            this.$emit('change:types', val)
        }
    }
}
</script>

<style scoped>
.types-picker {
    display: flex;
    gap: 16px;
}

.tp-col {
    flex: 1 1 0;
    min-width: 0;
}

@media (max-width: 767px) {
    .types-picker {
        flex-direction: column;
        gap: 12px;
    }
}
</style>
